// Node Module Imports
import { createGlobalStyle } from 'styled-components'
import './bootstrap/bootstrap.scss'

// Style Imports

// Asset Imports
import ChevWhiteEast from '../assets/svgs/chevron-pattern-white-east.svg'
import ChevWhiteNorth from '../assets/svgs/chevron-pattern-white-north.svg'
import ChevWhiteSouth from '../assets/svgs/chevron-pattern-white-south.svg'
import ChevWhiteWest from '../assets/svgs/chevron-pattern-white-west.svg'
import { rotate } from './animations'
import { above, colors, lineHeight, space, fontSize } from './design-system'

const GlobalStyle = createGlobalStyle`

  * {
    box-sizing: border-box;
  }

  html {
    font-size: 100%;
  }

  body {
    color: ${colors.dev.gray.b()};
    font-family: acumin-pro, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    font-size: 1rem;
    line-height: ${lineHeight.i};
    margin: 0;
    ${above.md`
      font-size: 1.2rem;
    `}
  }

  h1, .h1, 
  h2, .h2, 
  h3, .h3,
  h4, .h4, 
  h5, .h5, 
  h6, .h6 {
    font-family: acumin-pro-condensed;
    letter-spacing: 0.6px;
    line-height: ${lineHeight.f}; //this equals 1.05 font size
    margin-bottom: 1rem;
    margin-top: 1.25rem;
  }

  .jubilat {
    font-family: jubilat;
    font-style: italic;
    font-weight: 900;
  }

  .white { color: #fff; }
  a.white {
    color: #fff;
    &:hover {
      color: #fff;
    }
  }
  .black { color: #000;}
  .blue {color: ${colors.dev.blue.d()};}

  h1, .h1 {
    display: block;
    font-weight: bold;
    font-size: 1.5rem;
    ${above.tiny` font-size: 2rem; `}
    ${above.md` font-size: 3rem; `}
    ${above.lg` font-size: 3.5rem; `}
  }

  h2, .h2 {
    display: block;
    font-weight: bold;
    font-size: 1.25rem;
    ${above.tiny` font-size: 1.5rem; `}
    ${above.md` font-size: 1.75rem; `}
    ${above.lg` font-size: 2rem; `}
  }

  h3, .h3 {
    display: block;
    font-weight: bold;
    font-size: 1.125rem;
    ${above.tiny` font-size: 1.25rem; `}
    ${above.md` font-size: 1.375rem; `}
    ${above.lg` font-size: 1.5rem; `}
  }

  h4, .h4 {
    display: block;
    font-weight: bold;
    font-size: 1.25rem;
  }

  h5, .h5, h6, .h6 {
    display: block;
    font-weight: bold;
    font-size: 1rem;
  }

  body.modal-open, body.prevent-scroll {
    height: 100vh;
    overflow: hidden;
  }

  body.modal-open {
    #portal > div > div {
      z-index: 20;
    }
  }

  body.modal-two-open {
    height: 100vh;
    overflow: hidden;
    #portal-two > div > div {
      z-index: 30;
    }
  }

  p, ul {
    color: #444;
  }

  a {
    color: ${colors.dev.blue.d()};
    text-decoration: none;
  }

  img, iframe {
    border-radius: ${space.a};
    max-width: 100%;
  }

  small {
    font-size: .8rem;
  }

  .gatsby-image-wrapper {
    max-width: 100%;
  }

  .pointer {
    cursor: pointer;
  }

  .text-white-force *,
  .text-white-force p, 
  .text-white-force ul,
  .text-white-force li 
  .text-white-force a {
    color: #fff;
  }

  .text-white-force a:hover {
    color: #eee;
  }

  .underline {
    text-decoration: underline;
  }

  .hide-overflow {
    overflow: hidden;
  }

  .lead {
    font-size: 1rem;
    line-height: 1.25;
    margin-bottom: 1.5625rem;

    ${above.lg`
      font-size: ${fontSize.g};
      margin-bottom: 2.1875rem;
    `}
  }

  .no-outline, .no-outline:focus, .no-outline:active {
    outline: none;
  }

  .bg--blue-chev, .bg--green-chev, .bg--yellow-chev, .bg--red-chev, .bg--gray-chev {
    position: absolute;
    right: 0; left: 0; top: 0; bottom: 0;
    width: 100%;

    &::before {
      background-color: ${colors.dev.blue.d()};
      content: '';
      display: block;
      position: absolute;
        right: 0; left: 0; top: 0; bottom: 0;
      width: 100%;
    }
    &.north {
      &::after {
        background-image: url(${ChevWhiteNorth});
        background-size: 10.125rem 4.5rem;
      }
    }
    &.south {
      &::after {
        background-image: url(${ChevWhiteSouth});
        background-size: 10.125rem 4.5rem;
      }
    }
    &.east {
      &::after {
        background-image: url(${ChevWhiteEast});
        background-size: 4.5rem 10.125rem;
      }
    }
    &.west {
      &::after {
        background-image: url(${ChevWhiteWest});
        background-size: 4.5rem 10.125rem;
      }
    }

    &::after {      
      content: '';
      display: block;
      opacity: 0.075;
      position: absolute;
        right: 0; left: 0; top: 0; bottom: 0;
      width: 100%;
    }
  }

  .bg--green-chev::before {
    background-color: ${colors.dev.green.e()};
  }

  .bg--yellow-chev::before {
    background-color: ${colors.dev.yellow.e()};
  }

  .bg--red-chev::before {
    background-color: ${colors.dev.red.e()};
  }

  .bg--gray-chev::before {
    background-color: ${colors.dev.gray.e()};
  }

  .btn--strip {
    background-color: transparent;
    border: 0;
  }

  .nowrap {
    white-space: nowrap;
  }

  .upper {
    text-transform: uppercase;
  }
  
  hr {
    border: 0;
    border-bottom: .0625rem solid ${colors.umaCoolGray};
  }

  .bg-img--abs {
    background-size: cover;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
  }

  .video-wrapper {
    position: relative;
    padding-bottom: 56.25%;
    // padding-bottom: 51.64%;
    //padding-top: 1.5625rem;
    height: 0;
    overflow: hidden;
    width: 100%;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .dark-blue { color: ${colors.umaDarkBlue} }
  .bg-dark-blue { background-color: ${colors.umaDarkBlue} }
  .bg-green { background-color: ${colors.umaGreen} }
  .bg-light-gray, .bg-light-grey { background-color: ${colors.umaLightGray} }
  
  .bg-teal { background-color: ${colors.umaTeal} }

  .ultimate-light-gray, .ultimate-light-grey { color: ${colors.umaUltimateLightGray} }
  .light-gray, light-grey { color: ${colors.umaUltimateLightGray} }
  .cool-gray, .cool-grey { color: ${colors.umaCoolGray} }
  .cold-gray, .cold-grey { color: ${colors.umaColdGray} }
  .dark-gray, .dark-grey { color: ${colors.umaDarkGray} }

  .green { color: ${colors.umaGreen} }
  .light-blue { color: ${colors.umaLightBlue} }
  .orange { color: ${colors.umaOrange} }
  .pink { color: ${colors.umaPink} }
  .purple { color: ${colors.umaPurple} }
  .red { color: ${colors.umaRed} }
  .teal { color: ${colors.umaTeal} }
  .yellow { color: ${colors.umaYellow} }
  
  form {

    button {
      align-items: baseline;
      border-radius: ${space.a};
      display: flex;
      position: relative;
      transition: all 0.2s ease-in-out;

      &[disabled] {
        background-color: ${colors.dev.gray.c()} !important;
        background-image: none;
        color: #fff !important;
      }

      .spinner {
        display: inline-block;
        transition: all 0.2s ease-in-out;
        vertical-align: baseline;
      }

      &[disabled] .spinner {
        animation: ${rotate} 1s infinite;
        animation-delay: 0.3s;
        fill: #fff;
      }
    }
  }

  .list-style-ascii-chevron {

    ul {
      list-style: none;
      padding-left: 0;
    }
    
    li {
      margin-bottom: ${space.b};
      text-indent: -2.125rem;
      margin-left: 1.125rem;
      &::before {
        content: ">";
        margin: 0.5rem 0.5rem 0px 1rem;
      }
      li {
        text-indent: -2rem;
        &::before {
          content: '◦';
        }
      }
    }
    
  }

  .sr-only {
    position:absolute;
    left:-10000px;
    top:auto;
    width:1px;
    height:1px;
    overflow:hidden;
  }

  .list-style-none {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .lead {
      li {
        margin-bottom: 1em;
      }
  }

  .m-auto {
    margin: auto;
  }

  .container--sm {
    margin: 0 auto;
    max-width: 900px;
  }

  .container--md {
    margin: 0 auto;
    max-width: 1100px;
  }

  .dilute {
    color: ${colors.dev.gray.d()};
  }

  .btn {
    font-size: 1.2rem;
    white-space: nowrap;
    padding: ${space.d} ${space.e};
  }
  .btn-green, button[type="submit"] {
    color: #fff;
    background-color: ${colors.umaDarkGreen};
    background-image: linear-gradient(-180deg,${colors.umaGreen},${colors.umaDarkGreen} 90%);
    &:hover {
      background-color: ${colors.umaDarkGreen};
      background-image: none;
      color: #fff;
    }
  }

  // LivePerson Overrides
  .LPMcontainer[role="button"] {
    position: absolute !important;
    width: 100% !important;
    height: 100% !important;
  }

  .footnote__sup {
    font-weight: normal;
    font-size: .75em;
  }

  h1, h2 {
    .footnote__sup {
      font-size: .55em;
      top: -.6em;
    }
  }

  sup {
    top: -.35em;
  }

  .valign-baseline {
    vertical-align: baseline;
  }

  .ow-bw {
    overflow-wrap: break-word;
  }

  .button.sui-search-box__submit {
    background: linear-gradient(${colors.dev.blue.e()}, ${colors.dev.blue.d()}) ${colors.dev.blue.d()};
  }

  .object-fit-contain, .object-fit-contain img {
    object-fit: contain !important;
  }

  label.invisible-label {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  .lh-e {
    line-height: ${lineHeight.e};
  }

  .lh-1 {
    line-height: 1;
  }

  .bold {
    font-weight: bold;
  }

  .disclaimer {
    font-size: 12.8px;
  }

  .blog-content {
    li {
      margin-bottom: 6px;
    }

    blockquote, .section-highlight {
      background-color: hsla(0,3%,94%,1);
      border-left: 8px solid ${colors.umaLightBlue};
      border-radius: 4px;
      font-size: 1rem;
      margin-bottom: 1rem;
      padding: 1rem;

      p { margin-bottom: 1rem; }
      p:last-of-type {
        margin-bottom: 0;
      }

      footer {
        color: #444;
        margin-top: 1rem;
      }
    }
  }

  `

export default GlobalStyle
